import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { OfficeProvider } from "@/hooks/useOffice";
import { AuthProvider } from "@/hooks/useAuth";

function App() {
  return (
    <OfficeProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </OfficeProvider>
  );
}

export default App;